import { render, staticRenderFns } from "./MasivoCom.vue?vue&type=template&id=627bec23&"
import script from "./MasivoCom.vue?vue&type=script&lang=js&"
export * from "./MasivoCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports